import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/jobs/service-calls')({
  component: ServiceCallsIndexPage,
});

// The parent Jobs workspace owns the table and fixes it to service-call Jobs.
// This leaf only gives that operational lens a stable, bookmarkable route.
function ServiceCallsIndexPage() {
  return null;
}
